import { useSyncExternalStore } from "react";

/**
 * SSR-safe media-query hook. Returns whether `query` currently matches, and
 * re-renders on change. Server snapshot is `false` (mobile-first default).
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      if (typeof window === "undefined") return () => {};
      const mql = window.matchMedia(query);
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    },
    () =>
      typeof window !== "undefined" ? window.matchMedia(query).matches : false,
    () => false,
  );
}
